import { DobPipe } from '../../../pipes/dob.pipe';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasketDetail, MedicationDetail, isMedPicked } from '../../models/batchpick-state';

@Component({
  selector: 'app-box-grid',
  standalone: true,
  imports: [DobPipe, CommonModule],
  templateUrl: './box-grid.component.html',
  styleUrl: './box-grid.component.css',
})
export class BoxGridComponent {
  @Input() baskets: BasketDetail[] = [];
  @Input() currentBasket: number | null = null;
  @Input() pulseBasket: number | null = null;
  @Output() basketClick = new EventEmitter<BasketDetail>();

  pickedCount(b: BasketDetail): number {
    return b.medications.filter(this.isPicked).length;
  }

  isComplete(b: BasketDetail): boolean {
    return b.medications.length > 0 && b.medications.every(this.isPicked);
  }

  progressPercent(b: BasketDetail): number {
    if (b.medications.length === 0) return 0;
    return Math.round((this.pickedCount(b) / b.medications.length) * 100);
  }

  trackByBasket = (_: number, b: BasketDetail) => b.basketNumber;

  private isPicked = (m: MedicationDetail): boolean => isMedPicked(m);
}
